import PropTypes from 'prop-types';
import { WeightUnitValues } from '../enums/weight-unit';

export const WeightPropType = PropTypes.shape({
  unit: PropTypes.oneOf(WeightUnitValues),
  value: PropTypes.number,
});

/**
 * @typedef {(
 *   'Unknown'|
 *   'Ounces'|
 *   'Grams'|
 *   'Kilograms'|
 *   'Ounce'|
 *   'Gram'|
 *   'Kilogram'|
 *   'Pounds'|
 *   'Pound'
 * )} WeightUnit
 */

/**
 * @typedef {object} WeightPropType
 * @property {WeightUnit} unit
 * @property {number} value
 */
